import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { useApi } from "@/lib/api";
import { firebaseConfig, firebaseEnabled, getFirebase } from "@/lib/firebase";

const VAPID = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export function PushOptIn() {
  const api = useApi();
  const [state, setState] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  const [busy, setBusy] = useState(false);
  if (!firebaseEnabled || !VAPID || state === "granted" || state === "unsupported") return null;
  const enable = async () => {
    setBusy(true);
    try {
      if (!(await isSupported())) throw new Error("unsupported");
      const perm = await Notification.requestPermission();
      setState(perm);
      if (perm !== "granted") { toast.error("Notifications are blocked in your browser settings"); return; }
      const qs = new URLSearchParams({ apiKey: firebaseConfig.apiKey, projectId: firebaseConfig.projectId, appId: firebaseConfig.appId, senderId: firebaseConfig.messagingSenderId });
      const reg = await navigator.serviceWorker.register(`/firebase-messaging-sw.js?${qs}`);
      const token = await getToken(getMessaging(getFirebase()), { vapidKey: VAPID, serviceWorkerRegistration: reg });
      await api.post("/push/register", { token, platform: "web" });
      toast.success("Notifications turned on");
    } catch { toast.error("Couldn't turn on notifications in this browser"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-3xl border border-black/5 bg-white p-5" data-testid="push-optin">
      <p className="flex items-center gap-2 text-sm"><BellRing className="h-5 w-5 text-[#FF5A00]" />Get booking confirmations, pickup reminders and trip updates as notifications.</p>
      <button onClick={enable} disabled={busy || state === "denied"} data-testid="push-optin-enable" className="rounded-full bg-[#FF5A00] px-5 py-2.5 text-sm font-semibold text-white disabled:opacity-50">{state === "denied" ? "Blocked in browser" : busy ? "Turning on…" : "Turn on"}</button>
    </div>
  );
}
